import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { chesterfieldMOConfig } from "./data";

export default function ChesterfieldPage() {
  return <CityPageTemplate config={chesterfieldMOConfig} />;
}